module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Вы покинули встречу","description":"Вы успешно вышли из видеособеседования. Спасибо за участие.","rejoin":"Вернуться\\nк встрече","action":"Перейти\\nна Huntica"}}')
  delete Component.options._Ctor
}
